import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskedLines } from "@/components/Reveal";
import { CTAPrimary, CTASecondary } from "@/components/primitives";
import HeroNetwork from "@/components/HeroNetwork";

export default function HeroSection() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const yViz = useTransform(scrollYProgress, [0, 1], [0, 120]);
  const opacity = useTransform(scrollYProgress, [0, 0.85], [1, 0]);

  return (
    <section ref={ref} className="relative min-h-[100svh] flex items-center pt-28 pb-24 overflow-hidden grain" data-testid="hero-section">
      <motion.div style={{ y: yViz, opacity }} className="absolute inset-0 z-0 pointer-events-none">
        <div className="absolute inset-0 opacity-70"><HeroNetwork /></div>
        <div className="absolute inset-0 bg-gradient-to-r from-warm via-warm/70 to-transparent" />
      </motion.div>

      <div className="relative z-10 mx-auto max-w-[1500px] w-full px-6 md:px-10">
        <span className="load-fade-plain overline inline-flex items-center gap-3 text-navy/60" style={{ animationDelay: "0.1s" }}>
          <span className="w-8 h-px bg-gold" />Strategic Visibility Partner
        </span>

        <h1 className="mt-8 font-heading font-light text-navy tracking-tight text-[2.9rem] sm:text-6xl md:text-7xl lg:text-[5.4rem] max-w-[16ch]">
          <MaskedLines delay={0.2} lines={["Building Authority", "Where Business", "Decisions Are Made."]} />
        </h1>

        <p className="load-fade mt-10 max-w-2xl text-lg md:text-xl leading-relaxed text-ink/75 font-body" style={{ animationDelay: "0.85s" }}>
          HM Beacon maps the ecosystems around your business and orchestrates the visibility
          opportunities that put your company and its leaders in the right rooms.
        </p>

        <div className="load-fade mt-12 flex flex-col sm:flex-row gap-4" style={{ animationDelay: "1.0s" }}>
          <CTAPrimary to="/contact" testId="hero-primary-cta">Map Your Visibility</CTAPrimary>
          <CTASecondary to="/why" testId="hero-secondary-cta">Explore Our Approach</CTASecondary>
        </div>
      </div>

      <div className="absolute bottom-8 left-0 right-0 mx-auto max-w-[1500px] px-6 md:px-10 z-10">
        <div className="load-fade-plain flex items-center gap-4 text-navy/50 text-xs tracking-[0.2em] uppercase" style={{ animationDelay: "1.2s" }}>
          <span className="w-10 h-px bg-navy/30" />Visibility is not the destination. Authority is.
        </div>
      </div>
    </section>
  );
}
